import React, { Component } from 'react';
import Scheduler, { SchedulerData, ViewTypes } from 'flagstone-scheduler';
import 'flagstone-scheduler/lib/css/style.css'
import { withStyles } from "@material-ui/core/styles";
import withDragDropContext from '../../../Helpers/WithDndContext';
import { setSchedularData } from "../../../Helpers/setSchedularData";
import EditCreateOrderDrawer from "../../Planning/EditCreateOrderDrawer";
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import RestrictionsOverviewDrawer from '../../Planning/Restrictions/RestrictionsOverviewDrawer';
import CreateEditRestrictionDrawer from '../../Planning/Restrictions/CreateEditRestrictionDrawer'
import DateFnsUtils from '@date-io/date-fns';
import Popover from '@material-ui/core/Popover';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {
    DatePicker,

    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { IconButton, InputAdornment } from "@material-ui/core";
import WorkingHoursOverviewDrawer from '../../Planning/WorkingHours/WorkingHoursOverviewDrawer';
import EditWorkingHoursDrawer from '../../Planning/WorkingHours/EditWorkingHoursDrawer';
import ClosingDaysOverviewDrawer from '../../Planning/ClosingDays/ClosingDaysOverviewDrawer';
import CreateClosingDayDrawer from '../../Planning/ClosingDays/CreateClosingDayDrawer';
import { fromNewDateFormatToDDMMYYYY } from '../../../Helpers/dateHelper'
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import DeleteDialog from '../../Shared/Dialogs/DeleteDialog';
import { generateNewId } from '../../../Helpers/generalHelper';


class AppScheduler extends Component {
    constructor(props) {
        super(props);
        let schedularData = setSchedularData(props.workstation.workstations, props.order.productionOrders, props.order.articles, props.actions,props.planningViewType, props)

        this.state = {
            viewModel: schedularData,
            editCreateOrderDrawerOpen: false,
            restrictionsOverviewDrawerOpen: false,
            createEditRestrictionDrawerOpen: false,
            workingHoursOverviewDrawerOpen: false,
            closingDaysOverviewDrawerOpen: false,
            createClosingDayDrawerOpen: false,
            editWorkingHoursDrawerOpen: false,
            orderToEdit: null,
            orderIdToDelete: null,
            restrictionToEdit: null,
            start: null,
            end: null,
            workstation: null,
            restrictionAlertDialogOpen: false,
            deleteOrderDialogOpen: false,
            dialogTitle: "",
            dialogContext: "",
            date: props.planning.date,
            anchorEl: null
        }
    }

    prevClick = (schedulerData) => {
        schedulerData.prev();
        schedulerData.setEvents(this.props.planning.data.events);
        this.setState({
            viewModel: schedulerData
        })
    }

    nextClick = (schedulerData) => {
        schedulerData.next();
        schedulerData.setEvents(this.props.planning.data.events);
        this.setState({
            viewModel: schedulerData
        })
    }

    onViewChange = (schedulerData, view) => {
        schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
        schedulerData.setEvents(this.props.planning.data.events);
        this.setState({
            viewModel: schedulerData
        })
    }

    onSelectDate = (schedulerData, date) => {
        schedulerData.setDate(date);
        schedulerData.setEvents(this.props.planning.data.events);
        this.setState({
            viewModel: schedulerData
        })
    }

    setStart = (start) => {
        this.setState({
            start: start
        })
    }

    setEnd = (end) => {
        this.setState({
            end: end
        })
    }

    openDeleteOrderDialog = (schedularData, event) => {
        let ordernumber = this.props.order.productionOrders.find(x => x.id === event.id).ordernumber
        this.setState({ orderIdToDelete: event.id })
        this.setState({ dialogTitle: "Delete this order?" })
        this.setState({ dialogContext: "Are you sure deleting order '" + ordernumber + "'? " })
        this.setState({ deleteOrderDialogOpen: true })
    }


    deleteOrder = () => {
        let tempOrders = this.props.order.productionOrders
        let index = tempOrders.indexOf(tempOrders.find(x => x.id === this.state.orderIdToDelete))
        tempOrders.splice(index, 1)
        this.props.actions.setProductionOrders(tempOrders)
        setSchedularData(this.props.workstation.workstations, tempOrders, this.props.order.articles, this.props.actions, this.props)
    }

    saveOrder = (orderId, state, start, end) => {
        let workstation = this.props.order.productionOrders.find(x => x.id === orderId).workstation
        if (this.orderChangeAllowed(start, end, workstation)) {
            let tempOrders = this.props.order.productionOrders
            tempOrders.find(x => x.id === orderId).state = state
            tempOrders.find(x => x.id === orderId).start = start
            tempOrders.find(x => x.id === orderId).end = end
            this.props.actions.setProductionOrders(tempOrders)
            setSchedularData(this.props.workstation.workstations, tempOrders, this.props.order.articles, this.props.actions, this.props)
            this.props.actions.setPlanningDate(start)
            this.setState({ date: start })
        }
    }

    createOrder = (order) => {
        let tempOrders = this.props.order.productionOrders
        order.id = generateNewId(tempOrders)
        tempOrders.push(order)
        this.props.actions.setProductionOrders(tempOrders)
        setSchedularData(this.props.workstation.workstations, tempOrders, this.props.order.articles, this.props.actions, this.props)
        this.props.actions.setPlanningDate(order.start)
        this.setState({ date: order.start })

    }

    editOrder = (schedulerData, event) => {
        this.setState({ orderToEdit: this.props.order.productionOrders.find(x => x.id === event.id) })
        this.openEditCreateOrderDrawer(true)
    }

    newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
        if (this.orderChangeAllowed(start, end, slotName)) {
            this.setState({ start: start })
            this.setState({ end: end })
            this.setState({ orderToEdit: null })
            this.setState({ workstation: slotName })
            this.openEditCreateOrderDrawer(true)
        }
    }

    updateEventStart = (schedulerData, event, newStart) => {
        if (this.orderChangeAllowed(newStart, event.end, event.resourceId)) {
            let tempOrders = this.props.order.productionOrders
            tempOrders.find(x => x.id === event.id).start = newStart
            this.props.actions.setProductionOrders(tempOrders)
            setSchedularData(this.props.workstation.workstations, tempOrders, this.props.order.articles, this.props.actions, this.props)
            this.props.actions.setPlanningDate(newStart)
            this.setState({ date: newStart })
        }
    }

    updateEventEnd = (schedulerData, event, newEnd) => {
        if (this.orderChangeAllowed(event.start, newEnd, event.resourceId)) {
            let tempOrders = this.props.order.productionOrders
            tempOrders.find(x => x.id === event.id).end = newEnd
            this.props.actions.setProductionOrders(tempOrders)
            setSchedularData(this.props.workstation.workstations, tempOrders, this.props.order.articles, this.props.actions, this.props)
            this.props.actions.setPlanningDate(newEnd)
            this.setState({ date: newEnd })
        }
    }

    moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
        if (this.orderChangeAllowed(start, end, slotName)) {
            let tempOrders = this.props.order.productionOrders
            tempOrders.find(x => x.id === event.id).workstation = slotName
            tempOrders.find(x => x.id === event.id).start = start
            tempOrders.find(x => x.id === event.id).end = end
            this.props.actions.setProductionOrders(tempOrders)
            setSchedularData(this.props.workstation.workstations, tempOrders, this.props.order.articles, this.props.actions, this.props)
            this.props.actions.setPlanningDate(start)
            this.setState({ date: start })
        }
    }

    onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
        if (schedulerData.ViewTypes === ViewTypes.Day) {
            schedulerData.next();
            schedulerData.setEvents(this.props.planning.data.events);
            this.setState({
                viewModel: schedulerData
            });

            schedulerContent.scrollLeft = maxScrollLeft - 10;
        }
    }

    onScrollLeft = (schedulerData, schedulerContent, maxScrollLeft) => {
        if (schedulerData.ViewTypes === ViewTypes.Day) {
            schedulerData.prev();
            schedulerData.setEvents(this.props.planning.data.events);
            this.setState({
                viewModel: schedulerData
            });

            schedulerContent.scrollLeft = 10;
        }
    }

    onScrollTop = (schedulerData, schedulerContent, maxScrollTop) => {
        console.log('onScrollTop');
    }

    onScrollBottom = (schedulerData, schedulerContent, maxScrollTop) => {
        console.log('onScrollBottom');
    }

    toggleExpandFunc = (schedulerData, slotId) => {
        schedulerData.toggleExpandStatus(slotId);
        this.setState({
            viewModel: schedulerData
        });
    }

    openEditCreateOrderDrawer = (open) => {
        this.setState({
            editCreateOrderDrawerOpen: open
        })
    }

    openRestrictionsOverviewDrawer = (open) => {
        this.setState({
            restrictionsOverviewDrawerOpen: open
        })
        this.setState({ anchorEl: null })
    }

    openClosingDaysOverviewDrawer = (open) => {
        this.setState({
            closingDaysOverviewDrawerOpen: open
        })
        this.setState({ anchorEl: null })
    }

    openWorkingHoursOverviewDrawer = (open) => {
        this.setState({
            workingHoursOverviewDrawerOpen: open
        })
        this.setState({ anchorEl: null })
    }

    openCreateEditRestrictionDrawer = (open, id) => {
        this.setState({
            createEditRestrictionDrawerOpen: open
        })

        if (id === null || id === undefined) {
            this.setState({ restrictionToEdit: null })
        }
        else {
            this.setState({
                restrictionToEdit: JSON.parse(JSON.stringify(this.props.workstation.restrictions.find(x => x.id === id)))
            })
        }
    }

    openCreateClosingDayDrawer = (open) => {
        this.setState({
            createClosingDayDrawerOpen: open
        })
    }

    openEditWorkingHoursDrawer = (open) => {
        this.setState({
            editWorkingHoursDrawerOpen: open
        })
    }

    closeDialog = () => {
        this.setState({ restrictionAlertDialogOpen: false })
        this.setState({ deleteOrderDialogOpen: false })
    }

    orderChangeAllowed = (start, end, workstation, newOrder) => {

        if (!this.checkIfOrderDuringWorkingHours(start, end, workstation, null)) {
            return false;
        }

        if (!this.checkRestrictionOrderOverlapping(start, end, workstation,)) {
            return false;
        }

        return true;
    }

    checkRestrictionOrderOverlapping = (start, end, workstation, restrictions, orders) => {
        var y;
        if (orders) {
            for (y = 0; y < orders.length; y++) {
                //when creating restriction           
                if (!this.checkRestrictionsforOrder(orders[y].start, orders[y].end, orders[y].workstation, restrictions, true, false)) {
                    return false
                }
            }

            return true;
        }
        else {
            //when editing, creating orders
            return this.checkRestrictionsforOrder(start, end, workstation, this.props.workstation.restrictions, false, true)
        }
    }

    checkRestrictionsforOrder = (start, end, workstation, restrictions, createEditRestriction, createNewOrder) => {
        var i;
        let startOrder = new Date(start)
        let endOrder = new Date(end)
        for (i = 0; i < restrictions.length; i++) {

            let startRestriction = new Date(restrictions[i].start)
            let endRestriction = new Date(restrictions[i].end)
            let restrictionWorkstation = restrictions[i].workstation

            //Check closing day overlap with orders
            if (restrictionWorkstation === 0
                && startOrder.getDate() === startRestriction.getDate()
                && startOrder.getMonth() === startRestriction.getMonth()
                && startOrder.getFullYear() === startRestriction.getFullYear()) {

                this.setState({ dialogTitle: "Restriction Alert" })
                if (createNewOrder) {
                    this.setState({ dialogContext: "Impossible to create order on closing day " + fromNewDateFormatToDDMMYYYY(restrictions[i].start) + ", please reschedule the order or closing day!" })
                }
                else {
                    this.setState({ dialogContext: "Closing day overlap with planned order on production line " + workstation + " on " + fromNewDateFormatToDDMMYYYY(restrictions[i].start) + ", please reschedule the planned order or closing day!" })

                }
                this.setState({ restrictionAlertDialogOpen: true })
                return false;
            }

            if ((startOrder >= startRestriction && startOrder < endRestriction && restrictionWorkstation === workstation)
                || (endOrder > startRestriction && endOrder <= endRestriction && restrictionWorkstation === workstation)
                || (startOrder <= startRestriction && endOrder >= endRestriction && restrictionWorkstation === workstation)) {
                this.setState({ dialogTitle: "Restriction Alert" })
                let reason = ""
                if (restrictions[i].type === 1) {
                    reason = "Maintenance on production line " + workstation
                }
                if (restrictions[i].type === 2) {
                    reason = "Machine broken on production line " + workstation
                }
                if (restrictions[i].type === 3) {
                    reason = "Material deficit on production line " + workstation
                }

                if (createEditRestriction) {
                    reason = "Restriction overlap with order on production line " + workstation + " between " + restrictions[i].start + " and " + restrictions[i].end + ", please reschedule the order or restriction!"
                }
                else {
                    reason += " between " + restrictions[i].start + " and " + restrictions[i].end
                }

                this.setState({ dialogContext: reason })
                this.setState({ restrictionAlertDialogOpen: true })
                return false;
            }
        }

        return true;
    }

    checkIfOrderDuringWorkingHours = (start, end, workstation, changedWorkingHours) => {
        let startOrder = new Date(start)
        let endOrder = new Date(end)
        let dayOrder = endOrder.getDay()

        let workingHours = []
        if (changedWorkingHours) {
            workingHours = changedWorkingHours.filter(x => x.day === dayOrder && x.workstation === workstation)
        }
        else {
            workingHours = this.props.workstation.workingHours.filter(x => x.day === dayOrder && x.workstation === workstation)
        }

        let startArray = workingHours[0].start.split(':')
        let endArray = workingHours[0].end.split(':')
        let startHour = parseInt(startArray[0])
        let startMin = parseInt(startArray[1])
        let endHour = parseInt(endArray[0])
        let endMin = parseInt(endArray[1])

        if ((startOrder.getHours() > startHour || (startOrder.getHours() === startHour && startOrder.getMinutes() >= startMin))
            && (endOrder.getHours() < endHour || (endOrder.getHours() === endHour && endOrder.getMinutes() <= endMin))) {
            return true;
        }
        else {
            if (changedWorkingHours) {
                this.setState({ dialogTitle: "Shift Alert" })
                this.setState({ dialogContext: "There are planned orders between " + start + " and " + end + " on production line " + workstation + ", please reschedule the orders or the shift" })
                this.setState({ restrictionAlertDialogOpen: true })
            }
            else {
                this.setState({ dialogTitle: "Shift Alert" })
                this.setState({ dialogContext: "There is none-working time scheduled between " + start + " and " + end + " on production line " + workstation })
                this.setState({ restrictionAlertDialogOpen: true })
            }

            return false;
        }
    }

    handleClose = () => {
        this.setState({ anchorEl: null })
    };

    openPopover = (event) => {
        this.setState({ anchorEl: event.currentTarget })
    };

    dateChanged = (schedularData, date) => {
        this.setState({ date: date })

        let viewType = null
        if (new Date(this.state.tillDate) - new Date(date) < 86400000) {
            viewType = ViewTypes.Day
        }
        if (new Date(this.state.tillDate) - new Date(date) > 86400000) {
            viewType = ViewTypes.Week
        }
        if (new Date(this.state.tillDate) - new Date(date) > 604800000) {

            viewType = ViewTypes.Month
        }

        if (schedularData.viewType !== viewType) {
            schedularData.setDate(date)
            schedularData.setEvents(this.props.planning.data.events);
        }
        else {
            schedularData.setDate(date)
            schedularData.setEvents(this.props.planning.data.events);
        }

        this.setState({ viewModel: schedularData })
    }

    render() {
        const { viewModel } = this.state;
        const { classes } = this.props;

        const open = Boolean(this.state.anchorEl);
        const id = open ? 'simple-popover' : undefined;

        return (
            <div className={classes.background}>
                <div className={classes.spacer80}>
                    <div className={classes.planningTitle}>
                        Planning
                     </div>
                    <div className={classes.options}><button className={classes.optionsButton} onClick={this.openPopover}><MoreVertIcon style={{ height: "30px", width: "30px", fill: FlagstoneTheme.palette.primary.main }}></MoreVertIcon></button></div>

                    <div className={classes.dates}>
                        <div className={classes.date}>
                            <div className={classes.fromtill}>
                                Date
                            </div>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker className={classes.datePicker}
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd-MM-yyyy"
                                        onChange={date => this.dateChanged(viewModel, date)}
                                        size='small'
                                        value={this.state.date}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className={classes.inputAdornment} position="end">
                                                    <IconButton className={classes.iconButton}>
                                                        <img className={classes.calendar} alt="calendar" src={process.env.PUBLIC_URL + '/img/calendar.svg'}></img>
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                    </div>
                </div>
                <Scheduler className={classes.scheduler} schedulerData={viewModel}
                    prevClick={this.prevClick}
                    nextClick={this.nextClick}
                    onSelectDate={this.onSelectDate}
                    onViewChange={this.onViewChange}
                    eventItemClick={this.editOrder}
                    viewEventClick={this.openDeleteOrderDialog}
                    viewEventText="DELETE"
                    viewEvent2Text="EDIT"
                    viewEvent2Click={this.editOrder}
                    updateEventStart={this.updateEventStart}
                    updateEventEnd={this.updateEventEnd}
                    moveEvent={this.moveEvent}
                    newEvent={this.newEvent}
                    onScrollLeft={this.onScrollLeft}
                    onScrollRight={this.onScrollRight}
                    onScrollTop={this.onScrollTop}
                    onScrollBottom={this.onScrollBottom}
                    toggleExpandFunc={this.toggleExpandFunc}
                />
                <EditCreateOrderDrawer openDrawer={this.openEditCreateOrderDrawer} drawerOpen={this.state.editCreateOrderDrawerOpen} setStart={this.setStart} setEnd={this.setEnd} start={this.state.start} end={this.state.end} selectedWorkstation={this.state.workstation} productionOrder={this.state.orderToEdit} articles={this.props.order.articles} saveOrder={this.saveOrder} createOrder={this.createOrder} {...this.props}></EditCreateOrderDrawer>
                <EditWorkingHoursDrawer openDrawer={this.openEditWorkingHoursDrawer} drawerOpen={this.state.editWorkingHoursDrawerOpen} {...this.props} actions={this.props.actions} checkIfOrderDuringWorkingHours={this.checkIfOrderDuringWorkingHours}></EditWorkingHoursDrawer>
                <WorkingHoursOverviewDrawer openEditWorkingHoursDrawer={this.openEditWorkingHoursDrawer} openDrawer={this.openWorkingHoursOverviewDrawer} drawerOpen={this.state.workingHoursOverviewDrawerOpen} {...this.props} actions={this.props.actions}></WorkingHoursOverviewDrawer>
                <ClosingDaysOverviewDrawer openCreateClosingDayDrawer={this.openCreateClosingDayDrawer} openDrawer={this.openClosingDaysOverviewDrawer} drawerOpen={this.state.closingDaysOverviewDrawerOpen} {...this.props} actions={this.props.actions}></ClosingDaysOverviewDrawer>
                <CreateClosingDayDrawer openDrawer={this.openCreateClosingDayDrawer} drawerOpen={this.state.createClosingDayDrawerOpen} {...this.props} actions={this.props.actions} checkRestrictionOrderOverlapping={this.checkRestrictionOrderOverlapping}></CreateClosingDayDrawer>
                <RestrictionsOverviewDrawer openCreateEditRestrictionDrawer={this.openCreateEditRestrictionDrawer} openDrawer={this.openRestrictionsOverviewDrawer} drawerOpen={this.state.restrictionsOverviewDrawerOpen} {...this.props} actions={this.props.actions}></RestrictionsOverviewDrawer>
                <CreateEditRestrictionDrawer restriction={this.state.restrictionToEdit} openDrawer={this.openCreateEditRestrictionDrawer} drawerOpen={this.state.createEditRestrictionDrawerOpen} {...this.props} actions={this.props.actions} checkRestrictionOrderOverlapping={this.checkRestrictionOrderOverlapping}></CreateEditRestrictionDrawer>
                <AlertDialog {...this.props} dialogOpen={this.state.restrictionAlertDialogOpen} action={this.closeDialog} dialogTitle={this.state.dialogTitle} dialogContext={this.state.dialogContext}></AlertDialog>
                <DeleteDialog {...this.props} dialogOpen={this.state.deleteOrderDialogOpen} action={this.deleteOrder} closeDialog={this.closeDialog} dialogTitle={this.state.dialogTitle} dialogContext={this.state.dialogContext}></DeleteDialog>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <div className={classes.optionsMenu}>
                        <div className={classes.restrictionsOption}><button className={classes.optionsMenuItem} onClick={() => this.openRestrictionsOverviewDrawer(true)}>Workstation restrictions</button></div>
                        <div className={classes.workingHoursOption}><button className={classes.optionsMenuItem} onClick={() => this.openWorkingHoursOverviewDrawer(true)}>Working hours</button></div>
                        <div className={classes.closingDaysOption}><button className={classes.optionsMenuItem} onClick={() => this.openClosingDaysOverviewDrawer(true)}>Closing days</button></div>
                    </div>
                </Popover>
            </div>
        )
    }
}

const styles = {
    spacer80: {
        height: '80px',
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    },
    background: {
        height: '100vh',
        width: '100%',
        padding: "20px",
        boxSizing: "border-box",
        marginTop: "40px"
    },
    scheduler: {
        margin: "5px auto"
    },
    schedulerContainer: {

    },
    restrictions: {
        float: "right",
        marginBottom: "60px"
    },
    blockIcon: {
        color: FlagstoneTheme.palette.primary.main,
        width: "20px",
        height: "20px",
        float: "left"
    },
    restrictionsButton: {
        outline: "none",
        border: "none",
        cursor: "pointer",
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        width: "120px",
        marginBottom: "5px"

    },
    restrictionText: {
        paddingTop: "2px",
        marginLeft: "5px",
        float: "left"

    },
    planningTitle: {
        float: "left",
        width: "fit-content",
        position: "relative",
        top: "60px",
        paddingLeft: "0.8%"
    },
    fromtill: {
        display: 'block',
        color: '#020100',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    datePicker: {
        borderRadius: "6px",
        backgroundColor: "white",
        "& input": {
            fontSize: "14px !important",
            fontFamily: "Lato, sans-serif !important",
        },
        marginBottom: '10px',
        width: "90%"

    },
    date: {
        width: "100%",
        float: "left",
    },
    dates: {
        height: "50px",
        float: "right",
        paddingTop: "45px",
        width: "170px",
        marginRight: "20%"
    },
    options: {
        width: "20px",
        float: "right",
        position: "relative",
        top: "55px",
        right: "5px"
    },
    optionsButton: {
        border: "none",
        outline: "none",
        cursor: "pointer"
    },
    optionsMenu: {
        width: "180px",
        height: "120px"

    },
    restrictionsOption: {
        width: "100%",
        height: "40px",
        paddingTop: "12px",
        paddingLeft: "10px",
        boxSizing: "border-box",
        borderBottom: "1px solid #DEDEDE"

    },
    workingHoursOption: {
        width: "100%",
        height: "40px",
        paddingTop: "12px",
        paddingLeft: "10px",
        boxSizing: "border-box",
        borderBottom: "1px solid #DEDEDE"

    },
    closingDaysOption: {
        width: "100%",
        height: "40px",
        paddingTop: "12px",
        paddingLeft: "10px",
        boxSizing: "border-box"
    },
    optionsMenuItem: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    }
};

export default withStyles(styles)(withDragDropContext(AppScheduler))